import { TeamAgreementInterface } from '../Agreement/types';
import { OptionsInterface, PersonInterface } from '../Common/types';

// Verksamhetskategori, the kind of business a team works in
export type BusinessCategory = 'elderly_care' | 'lss' | 'home_visit';

export const businessCategoryOptions: { id: BusinessCategory; name: string }[] = [
  { id: 'elderly_care', name: 'Äldreboende' },
  { id: 'lss', name: 'LSS' },
  { id: 'home_visit', name: 'Hembesök' },
];

export interface TeamInterface {
  operational_manager?: OptionsInterface;
  regional_manager?: OptionsInterface;
  id?: number;
  name: string;
  notes: string;
  standard_attendance: number;
  standard_workday: number;
  residence_id?: number;
  residence_name?: string;
  created_at?: string;
  is_active: boolean;
  difficult: boolean;
  business_category?: BusinessCategory;
  editable?: boolean;
  deletable?: boolean;
  residence?: any;
  people_attributes?: PersonInterface[];
}

export interface TeamListInterface {
  id?: number;
  region_id: number;
  team_name: string;
  region: { name: string; id: number };
  residence: { name: string; id: number };
  residence_group: { name: string; id: number };
  no_employed: number;
  operational_manager?: { id: string; name: string; email: string };
  regional_manager?: { id: string; name: string; email: string };
  team_agreement: TeamAgreementInterface;
  team_leaders_emails: Array<string>;
  days_last_work_shift: number | null;
  attendance_last_work_shift: number | null;
  catastrophe_work_shifts: number;
  hours_current_period: number;
  hours_next_period: number;
  standard_attendance: number;
  standard_workday: number;
  latest_catastrophe_work_shift: number | null;
}

export interface MinimalTeam {
  id: number;
  name: string;
  is_active: boolean;
  standard_attendance: number;
  difficult: boolean;
  period_info?: TeamPeriodInfo;
}

export interface TeamExportData {
  id: number;
  name: string;
  people_attributes: PersonInterface[];
}

export interface TeamPeriodInfo {
  kp_2: number;
  kp_6: number;
  kp_12: number;
}
